import { ACTIVE_USERS_LIST_TAG } from '../constants';
import { api } from '../core';

export type UserDeactivateResponse = null;

export type UserDeactivateProps = {
  userToEditId: string;
};

const userDeactivateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postUserDeactivate: builder.query<UserDeactivateResponse, UserDeactivateProps>({
      query: ({ userToEditId }: UserDeactivateProps) => ({
        url: 'user/deactivate',
        method: 'POST',
        body: {
          userToEditId: userToEditId
        }
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([ACTIVE_USERS_LIST_TAG]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postUserDeactivate in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostUserDeactivateQuery } = userDeactivateApi;
